import { Badge, BadgeProps } from '@/components/ui/elements/badge';
import { WorkOrder } from '@/types';
import { STATUS_COLOR_CLASSES } from '../../utils/statusColors';

const statusVariantMap: Record<string, BadgeProps['variant']> = {
  Reported: 'gray',
  Investigating: 'blue',
  'Work Scheduled': 'indigo',
  'In Progress': 'yellow',
  'Problem!': 'red',
  'On Hold': 'orange',
  Duplicate: 'gray',
};

interface WorkOrderStatusBadgeProps {
  workOrder: Pick<WorkOrder, 'completed' | 'status'>;
  size?: BadgeProps['size'];
}

export const WorkOrderStatusBadge = ({ workOrder, size = 'xs' }: WorkOrderStatusBadgeProps) => {
  const status = workOrder.status;
  const variant = STATUS_COLOR_CLASSES[status || 'OK']?.badgeVariant ?? 'green';

  if (!status) return null;

  return (
    <>
      {workOrder.completed ? (
        <Badge variant="green" size={size}>
          Done
        </Badge>
      ) : (
        <Badge variant={variant} size={size}>
          {status}
        </Badge>
      )}
    </>
  );
};
